import * as React from 'react';
import Skeleton from './Skeleton';
import { renderFileSkeletons } from './skeletonUtils';
import { DisposableAlert } from '../DisposableAlert';
import { StatusBarAlert } from '../../statusBar/StatusBarAlert';
import { useDispatch, useSelector } from 'react-redux';
import { clearAlertText } from '../../../actions';

import './SaveViewSkeleton.scss';

const SaveViewSkeleton = () => {
  const alertText = useSelector((state) => state.app.alertText);
  const isAddingTime = useSelector((state) => state.time.isAddingTime);
  const isRemovingSaveLocation = useSelector((state) => state.mail.isRemovingSaveLocation);
  const dispatch = useDispatch();
  return (
    <div>
      { alertText && <DisposableAlert child={<StatusBarAlert />}
        disposeFunction={() => {
          !isAddingTime && !isRemovingSaveLocation && dispatch(clearAlertText());
        }}
        timeout={5000}
      />}
      <div id='status-bar'>
        <div className='skeleton-status'>
          <>
            <Skeleton width={'50%'}/>
            <Skeleton width={'50%'}/>
          </>
        </div>
      </div>
      <div>
        <div className="skeleton-header"><Skeleton width={'86px'} /></div>
        <div className={`selected-record-container`}>
          <div className={'skeleton-tableItem'} style={{ cursor: 'default' }}>
            <Skeleton className={'skeleton-itemImage'} height={'24px'} width={'24px'}/>
            <div className="skeleton-tableContainer" >
              <div><Skeleton margin={'1'} className=""/></div>
              <div><Skeleton margin={'1'} className={''} width={'83px'}/></div>
              <div><Skeleton margin={'1'} className={''} width={'111px'}/></div>
            </div>
          </div>
          <div id="outlook-folder-component" className={''}>
            <div className="skeleton-header"><Skeleton width={'86px'}/></div>
            <div className={`skeleton-componentItem`}>
              <Skeleton height={'24px'} width={'24px'}/>
              <div className='skeleton-tableContainer'>
                <Skeleton height={'15px'} width={'80%'} className={'skeleton-noMargin'}/>
              </div>
              <div className='skeleton-icons'>
                <Skeleton height={'15px'} width={'15px'} margin={'12px 0px 0px 0px'}/>
              </div>
            </div>
          </div>
          <div id="outlook-folder-component">
            <div className='skeleton-flex-header'>
              <span className='skeleton-flexGrow'><Skeleton width={'86px'}/></span>
            </div>
            {renderFileSkeletons(4)}
          </div>
          <div className='skeleton-saveContainer'>
            <Skeleton height={'32px'} width={'62px'} margin={'16px'} className={'skeleton-saveButton'} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveViewSkeleton;
